/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
import {
    unitBase,
    rowSpacing,
    fontSize,
    fontSizeDesktop,
    enterpriseCSS,
    paletteHD,
} from './variables';

import { StatusTrackingBar } from './common/StatusTrackingBar';

export const TrackOrderStyle = (typography, palette) => {
    const newPalette = !palette || !palette.cta1 ? paletteHD : palette;

    return {
        TrackOrderStyle: {
            // Delivery Hours
            '& .deliveryHours': {
                border: `2px solid ${newPalette.grey7}`,
                borderRadius: '4px',
                padding: `${unitBase * 2}px`,
                display: 'flex',
                alignItems: 'center',
                fontSize: fontSize.small,
                justifyContent: 'space-between',
                '& svg': {
                    paddingRight: unitBase,
                },
                '& .deliveryLabel': {
                    textTransform: 'uppercase',
                    whiteSpace: 'nowrap',
                    fontWeight: 700,
                    color: newPalette.grey4,
                    '& svg': {
                        verticalAlign: 'middle',
                        width: '24px',
                    },
                },
                '& > div': {
                    '& > div': {
                        display: 'inline-block',
                        lineHeight: '16px',
                    },
                    '& > svg': {
                        color: newPalette.grey6,
                        width: '16px',
                    },
                },
            },

            '& .desktop-no-orders': {
                fontWeight: 700,
                textAlign: 'center',
                marginTop: rowSpacing * 2,
            },

            '& .back-to-top-wrapper': {
                display: 'block',
                textAlign: 'center',
                margin: `${rowSpacing * 2}px 0`,
            },

            '& .back-to-top-link': {
                color: enterpriseCSS.palette.blue,
                fontWeight: 700,
                fontSize: fontSizeDesktop.small,
                textDecoration: 'none',
                position: 'relative',
                padding: 0,
                paddingRight: rowSpacing * 2,
                border: 0,
                background: 'transparent',
                '& > svg': {
                    position: 'absolute',
                    right: 0,
                    bottom: '-5px',
                },
            },

            // OrderList Item
            '& .orderListItem': {
                padding: rowSpacing,
                margin: `${rowSpacing}px -${rowSpacing}px`,
                borderTop: `1px solid ${enterpriseCSS.palette.gray2}`,

                '&.last': {
                    paddingBottom: `${rowSpacing * 2}px`,
                    borderBottom: `1px solid ${enterpriseCSS.palette.gray2}`,
                },

                '& .orderListProduct': {
                    '&::after': {
                        content: '""',
                        display: 'block',
                        borderBottom: `2px dashed ${enterpriseCSS.palette.gray3}`,
                        margin: `0 -${rowSpacing}px ${rowSpacing
                            * 2}px -${rowSpacing}px`,
                        paddingBottom: `${rowSpacing * 2}px`,
                    },
                    '&:last-child::after': {
                        borderBottom: 'none',
                        margin: 0,
                        padding: 0,
                    },
                },
            },

            // Status tracking bar
            ...StatusTrackingBar(typography, newPalette).StatusTrackingBar,
        },
    };
};
